/* Nordic Park — saved artworks (2026-10-22).
   A heart on collection-page and homepage cards and on the product page saves the ARTWORK (the product handle, never a variant).
   Saved handles live in this browser's localStorage, so nothing is sent anywhere and no app is needed.
   The header heart opens #nps-dialog, which fetches /products/<handle>.js for the saved items only when opened. */
(function () {
  var KEY = 'np_saved_v1', MAX = 100;
  var root = document.getElementById('nps-root');
  if (!root) return;
  var template = root.dataset.template;
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.4-4.5-9.2-9C1.5 8 3.5 4.6 7 4.6c2 0 3.6 1.1 5 3 1.4-1.9 3-3 5-3 3.5 0 5.5 3.4 4.2 6.7-1.8 4.5-9.2 9-9.2 9z"/></svg>';

  function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {} }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var list = read(), i = list.indexOf(h);
    if (i === -1) list.unshift(h); else list.splice(i, 1);
    write(list);
    try { if (i === -1 && window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('np_artwork_saved', { handle: h }); } catch (e) {}
    sync();
    if (i === -1) pulse();
    if (dialog && dialog.open) renderList();   // the Saved panel shows only what is still saved
    return i === -1;
  }
  function handleFrom(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : null; }

  /* every heart on the page + the header icon reflect the stored list */
  function sync() {
    var list = read();
    document.querySelectorAll('[data-nps-handle]').forEach(function (b) {
      var on = list.indexOf(b.dataset.npsHandle) !== -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? 'Remove from saved' : 'Save this artwork');
    });
    // on <html>, not the button: the theme re-renders the header (morph) on product pages and would wipe a class on it
    document.documentElement.classList.toggle('nps-has-saved', list.length > 0);
  }
  function pulse() { document.querySelectorAll('.nps-open').forEach(function (b) { b.classList.remove('is-pulse'); void b.offsetWidth; b.classList.add('is-pulse'); }); }

  function makeHeart(h, tag) {
    var el = document.createElement(tag);
    el.className = 'nps-heart';
    el.dataset.npsHandle = h;
    if (tag === 'span') { el.setAttribute('role', 'button'); el.tabIndex = 0; } else { el.type = 'button'; }
    el.innerHTML = HEART;
    return el;
  }

  /* collection pages + homepage rows: one heart per card, top right of the image; cards re-rendered by filters get theirs too */
  function decorateCards(scope) {
    (scope || document).querySelectorAll('a.v2c').forEach(function (card) {
      var wall = card.querySelector('.v2c__wall');
      if (!wall || wall.querySelector('.nps-heart')) return;
      var h = handleFrom(card.getAttribute('href'));
      if (h) wall.appendChild(makeHeart(h, 'span'));   // span: the card itself is a link, a <button> inside <a> is invalid
    });
  }

  /* product page: one heart, top right of the main gallery */
  function decorateProduct() {
    var h = handleFrom(location.pathname);
    var g = document.querySelector('#npcRoot .gallery') || document.querySelector('.product-media-container, media-gallery, .product__media');
    if (!h || !g || g.querySelector(':scope > .nps-heart')) return;
    if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
    g.appendChild(makeHeart(h, 'button')).classList.add('nps-heart--pdp');
  }

  function activate(e) {
    var b = e.target.closest('.nps-heart');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.dataset.npsHandle);
  }
  document.addEventListener('click', activate, true);
  document.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('nps-heart')) activate(e); }, true);
  // a tap on the heart must not start a card swipe or hydrate the card carousel
  ['pointerdown', 'touchstart'].forEach(function (t) { document.addEventListener(t, function (e) { if (e.target.closest && e.target.closest('.nps-heart')) e.stopPropagation(); }, { capture: true, passive: true }); });

  /* the Saved panel */
  var dialog = document.getElementById('nps-dialog');
  var cache = {};
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fetchProduct(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { cache[h] = p; return p; })
      .catch(function () { return null; });
  }
  function img(src) { if (!src) return ''; src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=200'; }
  function renderList() {
    var list = read(), box = dialog.querySelector('.nps-list');
    dialog.querySelector('.nps-count').textContent = list.length ? '(' + list.length + ')' : '';
    if (!list.length) { box.innerHTML = '<p class="nps-empty">Tap the ♡ on any artwork to save it here.</p>'; return; }
    box.innerHTML = list.map(function (h) { return '<li class="nps-row is-loading" data-row="' + esc(h) + '"><span class="nps-thumb"></span><span class="nps-title"></span></li>'; }).join('');
    list.forEach(function (h) {
      fetchProduct(h).then(function (p) {
        var row = box.querySelector('[data-row="' + CSS.escape(h) + '"]');
        if (!row) return;
        if (!p) { row.remove(); return; }   // product gone or unpublished: drop it quietly
        row.classList.remove('is-loading');
        row.innerHTML = '<a class="nps-thumb" href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image)) + '" alt="" loading="lazy" width="72" height="72"></a>' +
          '<a class="nps-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>';
        row.appendChild(makeHeart(h, 'button'));
        sync();
      });
    });
  }
  if (dialog) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('.nps-open')) { renderList(); dialog.showModal(); }
      else if (e.target.closest('.nps-close') || e.target === dialog) dialog.close();
    });
  }

  function run() {
    if (template === 'collection' || template === 'index') decorateCards();
    if (template === 'product') decorateProduct();
    sync();
  }
  run();
  // filters / pagination / the product configurator replace parts of the page: re-decorate what they bring in
  var main = document.getElementById('MainContent');
  if (main && (template === 'collection' || template === 'index' || template === 'product')) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return; queued = true;
      setTimeout(function () { queued = false; run(); }, 30);   // a timer, not requestAnimationFrame: rAF never fires in a background tab, which left hearts off cards that loaded later
    }).observe(main, { childList: true, subtree: true });
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
})();
